import { render, staticRenderFns } from "./StackIcon.vue?vue&type=template&id=23f0e551&"
import script from "./StackIcon.vue?vue&type=script&lang=ts&"
export * from "./StackIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports